/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useCallback} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import {login, register} from '../redux/AuthCRUD'
import {Link} from 'react-router-dom'
import Select from 'react-select'
import * as auth from '../redux/AuthRedux'
import * as accountRedux from '../../../store/account'
import Cookies from 'js-cookie'
import {AUTH_TOKEN_COOKIE_KEY} from '../../../constants'
import {useDispatch} from 'react-redux'
import MaskInput from '../../../components/MaskInput/MaskInput'
import * as sweetalert2 from "sweetalert2";

const initialValues = {
  company_Name: '',
  email: '',
  password: '',
  first_Name: '',
  last_Name: '',
  phone: '',
  erpType: '',
  ecommerceType: '',
}

const erpTypes = [{value: 1, label: 'Nebim'},
  {value: 2, label: 'Netsis'}, {value: 4, label: 'Logo'},{value: 11, label: 'Logo Tiger'}, {value: 5, label: 'Dia'}
  , {value: 6, label: 'Wolvox'}, {value: 10, label: 'WolvoxSDK'}, {value: 7, label: 'Microsoft Dynamics AX'},{value: 17, label: 'Microsoft Dynamics AX Rest API'},
  {value: 8, label: 'Uyumsoft'},{value: 9, label: 'Mikro'}, {value: 12, label: 'Gizsoft'}, {value: 13, label: 'Zirve'},{value: 14, label: 'Nebim Winner'},
  {value: 15, label: 'Eta'},{value: 16, label: 'Entegra'},{value: 18, label: 'UyumsoftPortal'},{value: 19, label: 'LucaPortal'},{value: 20, label: 'Shopier'}
  ,{value: 21, label: 'Logo iş Başı'},{value: 22, label: 'LucaNet'},{value: 23, label: 'LucaKoza'},{value: 24, label: 'TrendyolEfaturam'}]
const ecommerceTypes = [{value: 1, label: 'IKAS'}, {value: 2, label: 'Ideasoft'}, {value: 3, label: 'Sentos'},{value: 4, label: 'Tsoft'},{value: 5, label: 'Shopify'},{value: 6, label: 'Sopyo'},{value: 7, label: 'JetStok'},{value: 8, label: 'Elements'},{value: 9, label: 'Platin360'}]

const customStyles: any = {
  control: (provided: any, state: any) => ({
    ...provided,
    borderColor: '#f5f8fa',
    color: '#5e6278',
    transition: 'color .2s ease,background-color .2s ease',
    backgroundColor: '#eef3f7',
    lineHeight: 1.5,
    fontSize: '1.1rem',
    fontWeight: 500,
    minHeight: '42px',
    backgroundClip: 'padding-box',
    border: '1px solid #E4E6EF',
    outline: 'none',
    width: '100%',
  }),
}

const registrationSchema = Yup.object().shape({
  company_Name: Yup.string()
    .min(3, 'En az 3 karakter içermelidir.')
    .required('Şirket Adı adı zorunludur.'),
  email: Yup.string()
    .email('Geçerli bir e-posta adresi giriniz.')
    .min(3, 'En az 3 karakter içermelidir.')
    .required('E-Posta zorunludur.'),
  password: Yup.string().min(8, 'En az 8 karakter içermelidir.').required('Şifre zorunludur.'),
  first_Name: Yup.string().required('Ad zorunludur.'),
  last_Name: Yup.string().required('Soyad zorunludur.'),
  phone: Yup.string().required('Telefon zorunludur.'),
  erpType: Yup.string().required('Muhasebe programı zorunludur.'),
  ecommerceType: Yup.string().required('E-ticaret yazılımı zorunludur.'),
})

const Registration = () => {

  const dispatch = useDispatch()
  const setAccount = useCallback((data) => {
    dispatch(accountRedux.actions.setAccount(data))
  }, [dispatch])

  const loginAction = useCallback((data) => {
    dispatch(auth.actions.login(data))
  }, [dispatch])

  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setSubmitting(true)
      values.phone = values.phone.replace(/[^\d]/g, '')
      register(values)
        .then((res) => {
          if(!res.data.successful){
          const  errorMessageText:string =res.data.statusCode === 119 ? "Geçersiz eposta formatı. Lütfen e-posta adresini kontrol ediniz.":res.data.statusCode === 120 ?  "e-posta adresi türkçe karakter içeriyor. Lütfen e-posta adresini kontrol ediniz.":res.data.statusCode ===105 ? "Bu eposta adresine sahip kullanıcı kayıtlı. Lütfen e-posta adresini kontrol ediniz.":"Kayıt İşleminde Hata Oluştu.";
            sweetalert2.default.fire({
              text: errorMessageText,
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: 'Kapat',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
            })
            setSubmitting(false)
            return;
          }
          setAccount(res.data.data)
          login(values.email, values.password)
            .then((res) => {
              loginAction(res.data)
              Cookies.set(AUTH_TOKEN_COOKIE_KEY, res.data?.token)
              setSubmitting(false)
            })
            .catch(() => {
              sweetalert2.default.fire({
                text: "Kayıt işlemi başarısız. Lütfen site yöneticisi ile iletişime geçiniz",
                icon: 'error',
                buttonsStyling: false,
                confirmButtonText: 'Kapat',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
              })
              setSubmitting(false)
              return;
            })
        })
        .catch(() => {
          setSubmitting(false)
          setStatus('Kayıt işlemi hatalı...')
        })
    },
  })

  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_signup_form'
      onSubmit={formik.handleSubmit}
    >
      {/* begin::Heading */}
      <div className='mb-10 text-center'>
        {/* begin::Title */}
        <h1 className='text-dark mb-3'>Kayıt Ol</h1>
        {/* end::Title */}
      </div>
      {/* end::Heading */}

      {formik.status && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}

      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>Şirket Adı</label>
        <input
          placeholder='Şirket Adı'
          type='text'
          autoComplete='off'
          {...formik.getFieldProps('company_Name')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {'is-invalid': formik.touched.company_Name && formik.errors.company_Name},
            {
              'is-valid': formik.touched.company_Name && !formik.errors.company_Name,
            },
          )}
        />
        {formik.touched.company_Name && formik.errors.company_Name && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.company_Name}</span>
            </div>
          </div>
        )}
      </div>
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>E-Posta</label>
        <input
          placeholder='E-Posta'
          type='email'
          autoComplete='off'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            },
          )}
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div>
      <div className='mb-7 fv-row' data-kt-password-meter='true'>
        <div className='mb-1'>
          <label className='form-label fw-bolder text-dark fs-6'>Şifre</label>
          <div className='position-relative mb-3'>
            <input
              type='password'
              placeholder='Şifre'
              autoComplete='off'
              {...formik.getFieldProps('password')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {
                  'is-invalid': formik.touched.password && formik.errors.password,
                },
                {
                  'is-valid': formik.touched.password && !formik.errors.password,
                },
              )}
            />
            {formik.touched.password && formik.errors.password && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.password}</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>Ad</label>
        <input
          placeholder='Ad'
          type='text'
          autoComplete='off'
          {...formik.getFieldProps('first_Name')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {'is-invalid': formik.touched.first_Name && formik.errors.first_Name},
            {
              'is-valid': formik.touched.first_Name && !formik.errors.first_Name,
            },
          )}
        />
        {formik.touched.first_Name && formik.errors.first_Name && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.first_Name}</span>
            </div>
          </div>
        )}
      </div>
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>Soyad</label>
        <input
          placeholder='Soyad'
          type='text'
          autoComplete='off'
          {...formik.getFieldProps('last_Name')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {'is-invalid': formik.touched.last_Name && formik.errors.last_Name},
            {
              'is-valid': formik.touched.last_Name && !formik.errors.last_Name,
            },
          )}
        />
        {formik.touched.last_Name && formik.errors.last_Name && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.last_Name}</span>
            </div>
          </div>
        )}
      </div>
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>Telefon</label>
        <MaskInput
          {...formik.getFieldProps('phone')}
          mask='0 (599) 999-9999'
          placeholder='Telefon Numarası'
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {'is-invalid': formik.touched.phone && formik.errors.phone},
            {
              'is-valid': formik.touched.phone && !formik.errors.phone,
            },
          )}
        />
        {formik.touched.phone && formik.errors.phone && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.phone}</span>
            </div>
          </div>
        )}
      </div>

      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>Muhasebe Programı</label>
        <Select
          placeholder={'Muhasebe Programı Seçiniz'}
          options={erpTypes}
          styles={customStyles}
          name='erpType'
          onChange={(option) => {
            formik.setFieldValue('erpType', option?.value)
          }}
          onBlur={() => {
            formik.handleBlur({target: {name: 'erpType'}})
          }}
        />
        {formik.touched.erpType && formik.errors.erpType && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.erpType}</span>
            </div>
          </div>
        )}
      </div>
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>E-ticaret Yazılımı</label>
        <Select
          placeholder={'E-ticaret Yazılımı Seçiniz'}
          options={ecommerceTypes}
          styles={customStyles}
          name='erpType'
          onChange={(option) => {
            formik.setFieldValue('ecommerceType', option?.value)
          }}
          onBlur={() => {
            formik.handleBlur({target: {name: 'ecommerceType'}})
          }}
        />
        {formik.touched.erpType && formik.errors.ecommerceType && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.ecommerceType}</span>
            </div>
          </div>
        )}
      </div>

      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_up_submit'
          className='btn btn-lg btn-primary w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!formik.isSubmitting && <span className='indicator-label'>Kayıt Ol</span>}
          {formik.isSubmitting && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Lütfen bekleyin...{' '}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
        <Link to='/account/login'>
          <button
            type='button'
            id='kt_login_signup_form_cancel_button'
            className='btn btn-lg btn-light-primary w-100 mb-5'
          >
            Giriş Yap
          </button>
        </Link>
      </div>
      {/* end::Form group */}
    </form>
  )
}
export default Registration
